import { DatePipe } from '@angular/common';
import { ApiResponse } from './apiresponse';

export class Inquiry{
    id : number;
    personId : number;
    ori : string;
    oca : string;
    dateSubmitted : Date;
    ati : string;
    fbiAti : string;
    sid : string;
    dojDate : Date;
    dojStatus : number;
    fbiDate : Date;
    fbiStatus : number;
    informedDate : Date;
    informedStatus : number;
    institution : number;
    notes : string;
    timestamp : Date;
    empl : string;
    title : string;
    startOfMinistry : Date;
    endOfMinistry : Date;
    followUp : number;
    orgNotes : string;
    positionDescription : string;
    workWithChildren : string;
    workWithMoney : string;
    operateVehicle : string;
    handBookDate : Date;
    mailCode : string;
    ministryType : string;
    createdBy : string;
    createdTime : Date;
    lastUpdatedBy : string;
    lastUpdatedTime : Date;
    livescanInfoVO :LivescanInfo;
    
}
export class InquiryResponse {
    inquiryVOList: Array<Inquiry>;
    apiResponseVO: ApiResponse;
}


export class LivescanInfo {
    id: number;
    inquiryId: number;
    createDate: Date;
    aliasFirst: string;
    aliasLast: string;
    sex: string;
    height:string;
    weight:string;
    eyeColor: string;
    hairColor: string;
    address1:string;
    city: string;
    state: string;
    zip: string;
    placeOfBirth: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}


// export class LivescanResponse {
//     livescanInfoVO: Array<LivescanInfo>;
//     apiResponseVO: ApiResponse;
// }